export default __webpack_public_path__ + "static/media/Royal Dragon Elite Cuirass.0122b0a2.jpg";